import React, { useState } from "react";
import { useParams } from "react-router-dom";
import Settings from "./settings";
import Staff from "./staff";
import { FaRegCircleUser } from "react-icons/fa6";

const Profile = () => {
  const [activeTab, setActiveTab] = useState("settings");
  const { id: eventId } = useParams();

  const tabs = [
    { id: "settings", label: "Settings" },
    { id: "staff", label: "Staff Management" },
  ];

  return (
    <div>
      <div className="p-6">
        <div className="mb-8">
          <div className="flex items-center justify-between mb-6">
            <div className="flex items-center gap-4">
              <div className="p-2 bg-gradient-to-br from-blue-500 to-blue-600 rounded-xl shadow-lg shadow-blue-500/30">
                <FaRegCircleUser className="w-6 h-6 text-white" />
              </div>
              <div>
                <h1 className="text-lg font-bold text-gray-900">
                  Profile
                </h1>
                <p className="text-gray-600 text-xs">
                  Manage your account, and event staff
                </p>
              </div>
            </div>
          </div>
        </div>

        <div className="border-b border-slate-200">
          <nav className="-mb-px flex space-x-8">
            {tabs.map((tab) => (
              <button
                key={tab.id}
                onClick={() => setActiveTab(tab.id)}
                className={`
                  py-4 px-1 border-b-2 font-medium text-sm transition-colors
                  ${activeTab === tab.id
                    ? "border-blue-600 text-blue-600"
                    : "border-transparent text-slate-500 hover:text-slate-700 hover:border-slate-300"
                  }
                `}
              >
                {tab.label}
              </button>
            ))}
          </nav>
        </div>
      </div>

      <div>
        {activeTab === "settings" && <Settings />}
        {activeTab === "staff" && <Staff eventId={eventId} />}
      </div>
    </div>
  );
};

export default Profile;